export const mockMessages = [
  {
    id: "1",
    content: "Hello! How are you?",
    date: new Date().toLocaleString(),
    type: "post"
  },
  {
    id: "2",
    content: "Hi! I'm good, thanks. How about you?",
    date: new Date().toLocaleString(),
    type: "get"
  },
  {
    id: "3",
    content: "I'm doing great, just wanted to check in.",
    date: new Date().toLocaleString(),
    type: "post"
  },
  {
    id: "4",
    content: "That's awesome! Let's catch up soon.",
    date: new Date().toLocaleString(),
    type: "get"
  },
  {
    id: "5",
    content: "Sure, how about this weekend?",
    date: new Date().toLocaleString(),
    type: "post"
  }
];
